var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlReminder24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Control/Reminder24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconReminder",
    transform: "translate(2.000000, 2.000000)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2270723,15 L14.3333333,11.866976 L14.3333333,6.29411765 C14.3333333,3.84536292 12.6808602,2 10,2 C7.3191398,2 5.66666667,3.84536292 5.66666667,6.29411765 L5.66666667,11.866976 L3.77292769,15 L16.2270723,15 Z M12.8304388,17 C12.7814936,17.1458064 12.7202099,17.2956481 12.6444272,17.4472136 C12.1681379,18.3997923 11.2678263,19 10,19 C8.73217375,19 7.83186214,18.3997923 7.35557281,17.4472136 C7.27979006,17.2956481 7.21850636,17.1458064 7.1695612,17 L0.227072314,17 L3.66666667,11.3094946 L3.66666667,6.29411765 C3.66666667,2.78699003 6.16234169,-4.4408921e-16 10,0 C13.8376583,4.4408921e-16 16.3333333,2.78699003 16.3333333,6.29411765 L16.3333333,11.3094946 L19.7729277,17 L12.8304388,17 Z",
    id: "Rectangle-209-Copy"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlReminder24);
export default __webpack_public_path__ + "static/media/controlReminder24.3698438121ee3249d712801a5d26ef4a.svg";
export { ForwardRef as ReactComponent };